import FormatterV1 from '../V1/FormatterV1';
import React from 'react';
import { DeliveryTooltip } from './DeliveryTooltip';

export const MemberPriceContainerV2 = ({
	memberPrice,
	nowPrice,
	was,
	save,
	ProductMemberPriceFinanceQuote,
	PriceWithDelivery,
	inStock,
	Code,
	ColourId,
	State,
	FinancePromotions,
	productTitle,
	memberPricePod,
}) => {
	const memberSaving = nowPrice - memberPrice;

	return (
		<>
			<div
				className="memberprice-container px-3 py-2 rounded relative md:mt-2"
				data-testid="price-member">
				<div className="flex flex-col text-title lg:text-xs xl:items-baseline">
					<span className="member-price-title text-sm z-10 text-cta-mainhover lg:leading-snug xl:leading-snug mb-1">
						AO member price
					</span>
					<div className="flex flex-col xl:flex-row items-baseline">
						<span className="member-price text-lg md:text-lg lg:text-xl lg:text-sm 2xl:block text-cta-mainhover leading-none xl:leading-none">
							{FormatterV1.format(memberPrice)}
						</span>
						<div className="text-membersave text-caption font-bold text-deals xl:ml-1">
							{was > 0 && save > 0
								? `${FormatterV1.format(memberSaving)}\u00A0Extra\u00A0Saving`
								: `Save ${FormatterV1.format(memberSaving)}`}
						</div>
					</div>
				</div>
				<div className="text-body-xs text-water font-bold">
					<span>Free delivery</span>
					<DeliveryTooltip />
				</div>
			</div>
		</>
	);
};
